export default "__VITE_ASSET__94aa7bd2__"